<ng-container *transloco="let t">
  @if (isNavigating()) {
    <div aria-live="polite" class="fixed inset-x-0 top-0 z-50 flex justify-center px-4 pt-3" role="status">
      <div
        class="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-700 shadow-theme-md dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300">
        <lonniyire-spinner
          aria-hidden="true"
          class="text-brand-500 dark:text-brand-400"
          size="sm"
          [inline]="true"
          [label]="t('common.navigationLoading')" />
        <span>{{ t('common.navigationLoading') }}</span>
      </div>
    </div>
  }
  <router-outlet />
</ng-container>
